// import './App.css';
import Navbar from './components/Navbar/Navbar';
import { Route, Routes } from 'react-router-dom';
// import Home from './components/pages/Home';
// import Services from './components/pages/Services';
import Dashboard from './components/pages/Dashboard';
// import Gears from './components/pages/Gears';
// import Login from './components/pages/Login';
// import Pract from './components/pages/Pract';
// import Aboutus from './components/pages/Aboutus';
import Gallery from './components/pages/Gallery';
// import Dashboard from './components/pages/Events';
import Events from './components/pages/Events';
// import Users from './components/pages/Users';
// import Signup from './components/pages/Signup';
// import Footer from './components/Footer/Footer';
// import Jose from './components/pages/Jose';
// import Toolbar from  './components/Toolbar/Toolbar';

import './components/pages/mycss.css';
import Contents from './components/pages/Contents';
import Portfolio from './components/pages/Portfolio';
import FirebaseOperation from './components/pages/FirebaseOperation';
import Pract from './components/pages/Pract';

function App() {
  return (
     <div className='main-container'>
      <div className='main-header'>
        <Navbar />
      </div>
      <div className='main-body'></div>
      <Routes>
              <Route path='/' element={<Contents />}></Route>
              <Route path='/dashboard' element={<Dashboard/>}></Route>
              {/* <Route path='/services' element={<Services/>}></Route> */}
              {/* <Route path='/aboutus' element={<Aboutus />}></Route> */}
              {/* <Route path='/signup' element={<Signup/>}></Route> */}
              <Route path='/casting' element={<Events/>}></Route>
              <Route path='/portfolio' element={<Portfolio/>}></Route>
              <Route path='/gallery' element={<Gallery/>}></Route>
              {/* <Route path='/users' element={<Users/>}></Route> */}
              <Route path='/contents' element={<Contents/>}></Route>
              <Route path='/fboperation' element={<FirebaseOperation/>}></Route>
              <Route path='/pract' element={<Pract/>}></Route>
              {/* <Route path='/gears' element={<Gears/>}></Route> */}
              {/* <Route path='/login' element={<Login/>}></Route> */}
           </Routes>

    </div>
  );
}

export default App;
